var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Promote',{attrs:{"studentId":12}})
}
var staticRenderFns = []

export { render, staticRenderFns }